'use client';

import type { AnchorHTMLAttributes, ReactNode } from 'react';

interface TrackedLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  /** Matomo event category */
  trackCategory: string;
  /** Matomo event action */
  trackAction: string;
  /** Matomo event label (name) */
  trackLabel: string;
  children: ReactNode;
}

/**
 * An `<a>` tag that fires a Matomo trackEvent on click without
 * preventing the default navigation. Designed for use inside server
 * components that need client-side analytics.
 */
export function TrackedLink({
  trackCategory,
  trackAction,
  trackLabel,
  children,
  onClick,
  ...rest
}: TrackedLinkProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    window._paq?.push(['trackEvent', trackCategory, trackAction, trackLabel]);
    onClick?.(e);
  };

  return (
    <a onClick={handleClick} {...rest}>
      {children}
    </a>
  );
}
